export default __webpack_public_path__ + "static/B0271-b4d784ac651b4285d6e4ef072d73befc.png";